// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"a2bc9296","213":"db08d691","339":"ad1f80fc","373":"6bd8f8e8","846":"eb7249ee"}[chunkId] + ".chunk.js";
};